<template>
  <div class="col-lg-7" id="codeBlock">
    <div class="mb-2" v-for="(options, tag) in newOptions.fields">
      <div class="row field-row mb-2 align-items-center">
        <div class="col-4">
          <div class="field-title"><span class="text-capitalize">{{ tag }}</span> Field:</div>
        </div>
        <div class="col-8">
          <selectpicker v-model="options.type" :options="typeOptions" include-blank class="bg-white"/>
        </div>
      </div>

      <div class="row field-row mb-2 align-items-center" v-show="isCustomPIN(options.type)">
        <div class="col-4">
          <div class="field-title">PIN Length</div>
        </div>
        <div class="col-8 pr-0">
          <PinLengthSelection v-model="options.pinSettings.length" :id="`pin-length-${tag}`" />
        </div>
      </div>
    </div>

    <div class="row field-row mb-2 align-items-start">
      <div class="col-12 barcode-container field-title d-flex align-items-center" v-if="isOCRAvailable">
        <input name="ocr" id="ocr" type="checkbox" v-model="newOptions.ocr" />
        <label for="ocr" class="mb-0 ml-2">Barcode recognition</label>
      </div>

      <div class="col-12 barcode-container field-title d-flex align-items-center" v-if="isOCRAvailable && newOptions.ocr">
        <input name="ocrFallback" id="ocrFallback" type="checkbox" v-model="newOptions.ocrFallback">
        <label for="ocrFallback" class="mb-0 ml-2">OCR Fallback</label>
      </div>

      <div class="col-12 barcode-container field-title d-flex align-items-center">
        <input name="sumBased" id="sumBased" type="checkbox" v-model="newOptions.sumBased" />
        <label for="sumBased" class="mb-0 ml-2">Sum-based SN fields</label>
      </div>
    </div>
  </div>
</template>

<script>
import PinLengthSelection from './pinLengthSelection';
import selectpicker from './selectpicker.vue';
import { getLabel } from './fieldsDescription';

export default {
  name: 'codeBlock',
  props: ['stepsObj', 'stepOptions', 'blockClass'],
  components: {
    PinLengthSelection, selectpicker
  },
  data: function () {
    return {
      stepName: 'Code',
      newOptions: {
        ocr: false,
        ocrFallback: true,
        sumBased: false,
        fields: {
          physical: { type: '', pinSettings: { length: [] } },
          digital:  { type: '', pinSettings: { length: [] } }
        }
      }
    };
  },
  mounted: function () {
    this.newOptions = { ...this.newOptions, ...this.stepOptions };
  },
  computed: {
    step: function () {
      if (this.blockClass.length > 0) {
        return {
          blockClass: this.blockClass,
          options: {
            ...this.newOptions,
            ocr: this.isOCRAvailable && this.newOptions.ocr,
            ocrFallback: this.isOCRAvailable && this.newOptions.ocr && this.newOptions.ocrFallback,
          }
        };
      }
    },
    typeOptions: function () {
      const config = this.stepsObj.find(step => step.blockClass === this.blockClass).stepOptions;
      return config.fields.map(field => [field, getLabel(field)]);
    },
    isOCRAvailable() {
      const ocrTypes = ['CODE128', 'CostcoVAN', 'IABWithCheckDigit'];
      return Object.values(this.newOptions.fields).some(options => ocrTypes.includes(options.type));
    },
  },
  methods: {
    isCustomPIN(type) {
      return ['PINNumeric', 'PINAlphanumeric'].includes(type);
    },
  }
};
</script>
